import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NgIf } from '@angular/common';
import {
  FuseConfig,
  FuseConfigService,
  Scheme,
} from '@fuse/services/config';

import { Subject, takeUntil } from 'rxjs';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { STORAGE_KEYS } from 'app/core/storage/storage-prefix';

const IMPORTS = [
  NgIf,

  MatIconModule,
  MatButtonModule,
  MatTooltipModule,
];

@Component({
  selector: 'scheme',
  imports: [...IMPORTS],
  templateUrl: './scheme.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class SchemeComponent implements OnInit, OnDestroy {
  config: FuseConfig;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(private _fuseConfigService: FuseConfigService) { }

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._fuseConfigService.config$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config: FuseConfig) => {
        // Store the config
        this.config = config;
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Set the scheme on the config
   *
   * @param scheme
   */
  setScheme(scheme: Scheme): void {
    localStorage.setItem(STORAGE_KEYS.UI.SCHEME, scheme);
    this._fuseConfigService.config = { scheme };
  }

}
